import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';

import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import {DatePicker} from "material-ui-pickers";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import FormDialog from './form-dialog';

import {isNumLetter, getMessage} from '../../../../common/utils/validation';




const styles = theme => ({
    root:{
        width:'100%',
        paddingTop:5,
        paddingBottom:15,
        alignItems:'flex-end',
        borderBottom:'rgba(224, 224, 224, 1) solid 1px'
    },
    titles:{
        width:200,
        fontSize:'110%',
    },
    textInput : {
        width:250,
        marginRight:50,
    },
    convText : {
        paddingBottom:7,
        paddingLeft:7,
        color:'#FF0000'
    },
    relations:{
        color:'rgba(64,186,208,1)',
        fontSize:'80%',
        display:'block'
    },
    notRelations:{
        color:'rgba(0,0,0,0.64)',
        fontSize:'80%',
        display:'block'
    },


});


class innerForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            fixInputValue : props.row.fixValue,
            fixErrorText : null,
            conversions:props.row.conversion,
            openConversions:false,
        }
    }

    /** event handler **/
    handleFixTextChange = (event) =>{
        const {afterChangeFunc, dataIndex, row} = this.props;
        const columnType = row.columnType;
        if(columnType === "LETTER_NUMBER" && !isNumLetter(event.target.value)){
            this.setState({
                fixErrorText : getMessage("numLetter"),
                fixInputValue : !event.target.value ? null : event.target.value
            });
        }
        else{
            this.setState({
                fixErrorText : null,
                fixInputValue : !event.target.value ? null : event.target.value
            });
            if(afterChangeFunc) afterChangeFunc(dataIndex,"fixValue",!event.target.value ? null : event.target.value);
        }

    };

    handleFixDateChange = date => {
        const {afterChangeFunc, dataIndex} = this.props;
        if(afterChangeFunc) afterChangeFunc(dataIndex,"fixValue",date.format("YYYY/MM/DD"));
        this.setState({
            fixInputValue : !date ? null : date.format("YYYY/MM/DD")
        })
    };
    handleFixDateInputChange = (e) =>{
        if(!e.target.value){
            const {afterChangeFunc, dataIndex} = this.props;
            if(afterChangeFunc) afterChangeFunc(dataIndex,"fixValue",null);
            this.setState({
                fixInputValue : null
            })
        }
    };
    handleClickConversion = () =>{
        this.setState({
            openConversions : true
        })
    };

    afterDialogCancelFunc = () =>{
        this.setState({
            openConversions : false
        })
    };

    afterDialogOkFunc = (conversions) =>{
        const {afterChangeFunc, dataIndex} = this.props;
        if(afterChangeFunc) afterChangeFunc(dataIndex,"conversion",conversions);
        this.setState({
            conversions,
            openConversions : false
        })
    };


    render () {
        const { classes,row} = this.props;
        const { fixInputValue, fixErrorText, conversions, openConversions} = this.state;

        const inputDivide = "columnType" in row ? row.columnType : "STRING";
        const maxLength = "maxLength" in row ? row.maxLength : 10;

        const fixInputDisabled = row.relation.length > 0;
        const conversionDisabled = row.relation.length === 0;

        const inputForm = () =>{
            const fixTextValue = !(fixInputValue) ? "" : fixInputValue;
            const fixDateValue = !(fixInputValue) || inputDivide !== "DATE" ? null : moment(new Date(fixInputValue).toISOString());
            const fixIsError = (fixErrorText !== null);

            switch(inputDivide){
                case 'STRING':
                case 'LETTER_NUMBER':
                    return(
                        <TextField
                            label="固定値"
                            placeholder="固定値"
                            className={classes.textInput}
                            onChange={this.handleFixTextChange}
                            name="textValue"
                            inputProps={{
                                maxLength:maxLength
                            }}
                            value={fixTextValue}
                            disabled={fixInputDisabled}
                            error={fixIsError}
                            helperText={fixErrorText}
                        />
                    );
                case 'DATE':
                    return(
                        <DatePicker
                            keyboard
                            label="固定値"
                            value={fixDateValue}
                            onChange={this.handleFixDateChange}
                            onInputChange={this.handleFixDateInputChange}
                            format="YYYY/MM/DD"
                            className={classes.textInput}
                            invalidDateMessage="日付が正しくありません"
                            cancelLabel={"キャンセル"}
                            disabled={fixInputDisabled}
                        />
                    );
                default:
                    return(
                        <TextField
                            label="固定値"
                            placeholder="固定値"
                            className={classes.textInput}
                            onChange={this.handleFixTextChange}
                            name="textValue"
                            inputProps={{
                                maxLength:maxLength
                            }}
                            value={fixTextValue}
                            disabled={fixInputDisabled}
                            error={fixIsError}
                            helperText={fixErrorText}
                        />
                    );
            }

        };

        const relation_text = (row.relation.length) ? <span className={classes.relations}>{row.relation.join(" + ")}</span> : <span className={classes.notRelations}>紐付け設定なし</span>;

        return ([
            <FormGroup className={classes.root} row key={"group"}>
                <Typography className={classes.titles}>
                    {row.label}
                    {relation_text}
                </Typography>
                {inputForm()}
                <Button variant="contained" color="primary" disabled={conversionDisabled} onClick={this.handleClickConversion}>
                    データ変換
                </Button>
                {conversions.length > 0 &&
                <Typography className={classes.convText}>
                    ※データ変換設定あり
                </Typography>
                }
            </FormGroup>,
            <FormDialog
                open={openConversions}
                key={"dialog"}
                conversion={conversions}
                afterCancelFunc={this.afterDialogCancelFunc}
                afterOkFunc={this.afterDialogOkFunc}
            />
        ]);
    }
}
innerForm.propTypes = {
    row : PropTypes.object,
    dataIndex : PropTypes.number,
    afterChangeFunc : PropTypes.func
};
innerForm.defaultProps = {
    row : {}
};
export default withStyles(styles)(innerForm);



// WEBPACK FOOTER //
// ./src/routes/mapping/step3/components/inner-form.js